<article class="product-card">
  <div class="product-card-top">
    <div>
      <span class="product-eyebrow">{{ product.operationKey }}</span>
      <h3>{{ product.itemTitle ?? 'Produto sem título' }}</h3>
      <p>{{ product.itemId ?? '-' }} · {{ listingTypeLabel }}</p>
      <p>Venda: {{ product.saleDate ? (product.saleDate | date : 'dd/MM/yyyy HH:mm') : '-' }}</p>
    </div>
    <div class="product-avatar">{{ productInitial() }}</div>
  </div>

  <div class="product-sales">
    <span>Total de vendas</span>
    <strong>{{ product.grossRevenue | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
  </div>

  <div class="product-cost-list">
    <div class="product-cost-line">
      <span class="cost-icon tone-return">↩</span>
      <span>(-) Devoluções</span>
      <strong>{{ product.returnCostAmount | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-fee">%</span>
      <span>(-) Comissão ML/MP</span>
      <strong>{{ product.platformFeeAmount | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-ads">A</span>
      <span>(-) Publicidade</span>
      <strong>{{ productAdsCost() | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-fixed">F</span>
      <span>(-) Custos fixos</span>
      <strong>{{ productFixedCost() | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-ads">D</span>
      <span>(-) Desconto do vendedor</span>
      <strong>{{ productSellerDiscount() | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-fixed">▣</span>
      <span>(-) Frete pago pelo vendedor</span>
      <strong>{{ productFreightCost() | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
    <div class="product-cost-line">
      <span class="cost-icon tone-fee">▤</span>
      <span>(-) Impostos</span>
      <strong>{{ product.taxesAmount | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
    </div>
  </div>

  <div class="product-margin" [ngClass]="productMarginClass()">
    <div>
      <span class="margin-badge">↗</span>
      <span>(=) Margem Líquida</span>
    </div>
    <div>
      <strong>{{ product.netResult | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong>
      <p>Margem: {{ product.marginPct === null ? '-' : (product.marginPct | number : '1.2-2') + '%' }}</p>
    </div>
  </div>
</article>
